import { BUTTON_CELL_DISPLAY_NAME } from "./core";
import createTestId from "../../../../fabrics/createTestId";

export const createTestIdForButtonCellElement = createTestId(
    BUTTON_CELL_DISPLAY_NAME,
);
